import React, { useState } from "react";
import { Check, Loader2, ArrowRight } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export function CommunitySignup({ locations = [] }) {
  const [form, setForm] = useState({ name: "", email: "", location_preference: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading"); setError("");
    try {
      await api.post("/community", form);
      setState("done");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setState("idle");
    }
  };

  return (
    <div data-testid="community-signup" className="relative overflow-hidden rounded-3xl glass p-8 sm:p-14 glow-blue">
      <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-electric/20 blur-3xl" />
      <div className="relative grid md:grid-cols-2 gap-10 items-center">
        <div>
          <span className="label">Join the community</span>
          <h3 className="font-display text-4xl sm:text-5xl font-bold text-white mt-4 leading-[1.05]">
            Come and be<br />part of it.
          </h3>
          <p className="text-ice/70 mt-5 max-w-sm leading-relaxed">
            As the programme and community grow, more classes and locations will be added. Be the first to know.
          </p>
        </div>

        {state === "done" ? (
          <div data-testid="community-success" className="text-center md:text-left">
            <div className="inline-flex h-14 w-14 rounded-full bg-cyan/15 items-center justify-center mb-4">
              <Check className="text-cyan" size={28} />
            </div>
            <h4 className="font-display text-2xl text-white">Welcome in.</h4>
            <p className="text-ice/70 mt-2">You'll hear from us soon.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="community-name" required placeholder="Name" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none" />
            <input data-testid="community-email" required type="email" placeholder="Email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none" />
            <select data-testid="community-location" value={form.location_preference}
              onChange={(e) => setForm({ ...form, location_preference: e.target.value })}
              className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice focus:border-cyan/60 outline-none">
              <option value="">Studio / location preference</option>
              {locations.map((l) => <option key={l.id} value={l.name}>{l.name}</option>)}
              <option value="No preference">No preference</option>
            </select>
            <button data-testid="community-submit" type="submit" disabled={state === "loading"} className="book-cta w-full justify-center">
              {state === "loading" ? <Loader2 className="animate-spin" size={16} /> : <>Join the community <ArrowRight size={16} /></>}
            </button>
            {error && <p className="text-red-300 text-sm" data-testid="community-error">{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
}

export default CommunitySignup;
